import {TagProps} from 'antd';

import * as cssVariableStyles from '../../../../../../css/var-export.scss';
import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {AiMonitoringSentimentEnum} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

// An aspect's sentiment runs -100..100; anything inside the thresholds reads as neutral.
export const POSITIVE_SENTIMENT_THRESHOLD = 15;
export const NEGATIVE_SENTIMENT_THRESHOLD = -15;
export const SENTIMENT_MAX = 100;

// A bar grows from the centre line, so a full-strength sentiment fills half the track.
export const SENTIMENT_BAR_MAX_WIDTH_PERCENT = 50;

export const ASPECT_BAR_COLOR_MAP: Record<AiMonitoringSentimentEnum, string> = {
    [AiMonitoringSentimentEnum.positive]: cssVariableStyles.sentiment_positive,
    [AiMonitoringSentimentEnum.negative]: cssVariableStyles.sentiment_negative,
    [AiMonitoringSentimentEnum.neutral]: cssVariableStyles.sentiment_unspecified,
};

export const ASPECT_TAG_COLOR_MAP: Record<AiMonitoringSentimentEnum, TagProps['color']> = {
    [AiMonitoringSentimentEnum.positive]: 'green',
    [AiMonitoringSentimentEnum.negative]: 'red',
    [AiMonitoringSentimentEnum.neutral]: 'default',
};

export const ASPECT_LANG_KEY_MAP: Record<AiMonitoringSentimentEnum, LangKeyType> = {
    [AiMonitoringSentimentEnum.positive]: 'AI_BRAND_MONITORING__TONALITY__POSITIVE',
    [AiMonitoringSentimentEnum.negative]: 'AI_BRAND_MONITORING__TONALITY__NEGATIVE',
    [AiMonitoringSentimentEnum.neutral]: 'AI_BRAND_MONITORING__TONALITY__NEUTRAL',
};
